import {
	OPEN_MODAL_SUCCESS,
	OPEN_MODAL_FAIL,
	CLOSE_MODAL_SUCCESS,
	CLOSE_MODAL_FAIL,
} from './types';

const initialState = {
	clientDetails: false,
	addDocument: false,
	addLeads: false,
	leadDetails: false,
	reviewAps: false,
	filterLeads: false,
	cobroker: false,
	lawyer: false,
	mortgage: false,
	docFormField: false,
	auditTrail: false,
	extendCoolingPeriod: false,
	depositSchedule: false,
	scheduleMeeting: false,
	addUserMgmt: false,
	addProjects: false,
	editAccessibility: false,
	resetPassword: false,
	addRole: false,
	roleActions: false,
	purchaser: false,
	verification: false,
	reviewFloorplans: false,
	loading: true,
};

export default function (state = initialState, action) {
	const { type, payload } = action;
	switch (type) {
		case OPEN_MODAL_SUCCESS:
		case OPEN_MODAL_FAIL:
		case CLOSE_MODAL_SUCCESS:
		case CLOSE_MODAL_FAIL:
			return {
				...state,
				clientDetails: payload['clientDetails']
					? payload['clientDetails']
					: false,
				addDocument: payload['addDocument']
					? payload['addDocument']
					: false,
				addLeads: payload['addLeads'] ? payload['addLeads'] : false,
				leadDetails: payload['leadDetails']
					? payload['leadDetails']
					: false,
				reviewAps: payload['reviewAps'] ? payload['reviewAps'] : false,
				filterLeads: payload['filterLeads']
					? payload['filterLeads']
					: false,
				cobroker: payload['cobroker'] ? payload['cobroker'] : false,
				lawyer: payload['lawyer'] ? payload['lawyer'] : false,
				mortgage: payload['mortgage'] ? payload['mortgage'] : false,
				docFormField: payload['docFormField']
					? payload['docFormField']
					: false,
				auditTrail: payload['auditTrail']
					? payload['auditTrail']
					: false,
				extendCoolingPeriod: payload['extendCoolingPeriod']
					? payload['extendCoolingPeriod']
					: false,
				depositSchedule: payload['depositSchedule']
					? payload['depositSchedule']
					: false,
				scheduleMeeting: payload['scheduleMeeting']
					? payload['scheduleMeeting']
					: false,
				addUserMgmt: payload['addUserMgmt']
					? payload['addUserMgmt']
					: false,
				addProjects: payload['addProjects']
					? payload['addProjects']
					: false,
				editAccessibility: payload['editAccessibility']
					? payload['editAccessibility']
					: false,
				resetPassword: payload['resetPassword']
					? payload['resetPassword']
					: false,
				addRole: payload['addRole'] ? payload['addRole'] : false,
				roleActions: payload['roleActions']
					? payload['roleActions']
					: false,
				purchaser: payload['purchaser'] ? payload['purchaser'] : false,
				verification: payload['verification']
					? payload['verification']
					: false,
				reviewFloorplans: payload['reviewFloorplans']
					? payload['reviewFloorplans']
					: false,
				loading: false,
			};
		default:
			return state;
	}
}
